// :: User Store
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import register from "./register";
// :: State
const state = {
  data: {},
  loggedIn: false,
  userAccess: {},
  userName: "",
  userBranch: "",
  userOnline: false,
  showTutorialVideo: false
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules: {
    register
  }
};
